import { axiosAiq } from 'config';
import { getFormattedErrorMessage } from 'utils/utils';

// Body is serialized snake_case on the backend (@JsonNaming(SnakeCaseStrategy)) -> send `gate_id`.
export const pinLane = (gateId) => axiosAiq.post('/sticky-lane/pin', { gate_id: gateId });

export const unpinLane = (gateId) => axiosAiq.post('/sticky-lane/unpin', { gate_id: gateId });

export const getActiveStickyLanes = async () => {
    const response = await axiosAiq.get('/sticky-lane/active');
    return response.data;
};

// Creates an update-free transaction for a pinned lane and returns a DeskAssignedMessage-shaped payload
// that can be fed straight into the standard new-transaction pipeline (handleDeskAssignedMessage).
export const createStickyLaneTransaction = async (gateId) => {
    const response = await axiosAiq.post('/sticky-lane/new-transaction-event', { gate_id: gateId });
    return response.data;
};

// Shared with stickyLaneSagas.js so pin/unpin/new-transaction errors are formatted the same way.
export const getStickyLaneErrorMessage = (err) =>
    getFormattedErrorMessage(err?.response?.data?.message ?? err?.response?.data?.error ?? err?.message);
